import tourManager from '../TourManager'
import demoStore from './mock/DemoStore'
import { demoRoutes, setDemoTourResume } from './DemoFlow'
import { enableDemoInterceptor } from './mock/axiosDemoInterceptor'

export const DEMO_PARAM_LIBERADA_INDEX = 2
export const DEMO_EQUIPAMENTO_LISTA_INTRO_INDEX = 2
export const DEMO_CLIENTE_LISTA_INTRO_INDEX = 1
export const DEMO_MONITORADO_LISTA_INTRO_INDEX = 1
export const DEMO_MONITORADO_PARAMS_TAB_INDEX = 9
export const DEMO_MONITORADO_DEMO_CONCLUIDA_INDEX = 5

export const DEMO_SKIP_TARGETS = {
    equipamentoListaIntro: {
        tour: 'demo-equipamento',
        resumeIndex: DEMO_EQUIPAMENTO_LISTA_INTRO_INDEX,
        path: demoRoutes.equipamentoLista,
    },
    paramLiberada: {
        seed: 'equipamento',
        tour: 'demo-parametrizacao',
        resumeIndex: DEMO_PARAM_LIBERADA_INDEX,
        path: demoRoutes.equipamentoEdit,
    },
    perfilMenu: {
        seed: 'param',
        tour: 'demo-perfil-cliente',
        resumeIndex: 0,
        path: demoRoutes.perfilLista,
    },
    clienteLista: {
        seed: 'perfil',
        tour: 'demo-cliente',
        resumeIndex: DEMO_CLIENTE_LISTA_INTRO_INDEX,
        path: demoRoutes.clienteLista,
    },
    monitoradoLista: {
        seed: 'cliente',
        tour: 'demo-monitorado',
        resumeIndex: DEMO_MONITORADO_LISTA_INTRO_INDEX,
        path: demoRoutes.monitoradoLista,
    },
    monitoradoParams: {
        seed: 'monitorado',
        tour: 'demo-monitorado',
        resumeIndex: DEMO_MONITORADO_PARAMS_TAB_INDEX,
        path: demoRoutes.monitoradoEdit,
    },
    monitoradoDemoLista: {
        seed: 'params-edit',
        tour: 'demo-monitorado-demo',
        resumeIndex: 0,
        path: demoRoutes.listaMonitorados,
    },
    monitoradoDemoConcluida: {
        seed: 'monitorado-demo',
        tour: 'demo-monitorado-demo',
        resumeIndex: DEMO_MONITORADO_DEMO_CONCLUIDA_INDEX,
        path: '/',
    },
}

const applySeed = (seed) => {
    enableDemoInterceptor()

    if (seed === 'equipamento') {
        demoStore.load()
        if (!demoStore.state.equipamento) {
            demoStore.createEquipamento()
        }
        return
    }

    if (seed) {
        demoStore.seedThroughStage(seed)
    }
}

export const skipDemoStage = (targetKeyOrConfig) => {
    const target =
        typeof targetKeyOrConfig === 'string'
            ? DEMO_SKIP_TARGETS[targetKeyOrConfig]
            : targetKeyOrConfig

    if (!target?.tour) return

    applySeed(target.seed)
    setDemoTourResume(target.tour, target.path, target.resumeIndex ?? 0)

    if (tourManager.isActive()) {
        tourManager.destroy()
    }

    const resumeIndex = target.resumeIndex ?? 0
    const path = target.path || '/'

    const startTour = () => {
        setTimeout(async () => {
            try {
                await tourManager.start(target.tour, { resumeIndex })
            } finally {
                tourManager.internalNavigation = false
            }
        }, 400)
    }

    tourManager.internalNavigation = true

    if (!tourManager.history) {
        tourManager.internalNavigation = false
        window.location.href = path
        return
    }

    const alreadyOnTarget = window.location.pathname === path.split('?')[0]
    if (alreadyOnTarget) {
        tourManager.history.replace(path)
        startTour()
        return
    }

    tourManager.history.push(path)
    startTour()
}

export const skipStageConfig = (targetKey, label = 'Pular etapa') => ({
    label,
    onSkip: () => skipDemoStage(targetKey),
})
